import { Group, Paper } from '@mantine/core'
import type { ReactNode } from 'react'

type MessageBubbleProps = {
  children: ReactNode
  align?: 'left' | 'right'
  tone?: 'assistant' | 'user'
}

export default function MessageBubble({ children, align = 'left', tone = 'assistant' }: MessageBubbleProps) {
  return (
    <Group justify={align === 'right' ? 'flex-end' : 'flex-start'}>
      <Paper
        p="md"
        radius="lg"
        withBorder
        style={(theme) => ({
          maxWidth: '80%',
          backgroundColor: tone === 'user' ? theme.colors.teal[6] : theme.white,
          color: tone === 'user' ? theme.white : theme.black,
        })}
      >
        {children}
      </Paper>
    </Group>
  )
}
